import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateSecondStepGeneralsNestedFields } from "../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../redux/reducers/visibilityMatrixesReducer";
import { Checkbox } from "@nn-design-system/react-component-library";
import WholeLineContainer from "../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { StoreType } from "../../../../../../redux/store/store";
import { useScrollToTopErrorInput } from "../../../../../../CustomHooks/useScrollToTopErrorInput";

const ThroutfulPersonIsContactAddressDifferent: React.FC = () => {
   const dispatch = useDispatch();
   const fieldNameLowerCase = "throutfulPersonIsContactAddressDifferent";
   const fieldNameUpperCase =
      fieldNameLowerCase.charAt(0).toUpperCase() + fieldNameLowerCase.slice(1);

   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.personModel.personThroutful[fieldNameLowerCase]
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameUpperCase);
   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "GeneralFields",
            fieldNameUpperCase,
            visibilityMatrixes
         )}
      >
         <div ref={ref}>
            <Checkbox
               labelText="Kontaktní adresa se liší od adresy trvalého pobytu."
               variant="Small"
               onChange={(e) => {
                  dispatch(
                     updateSecondStepGeneralsNestedFields({
                        value: !fieldValue,
                        sectionName: "personThroutful",
                        field: fieldNameLowerCase,
                     })
                  );
               }}
               dataState={fieldValue ? "Checked" : "NotChecked"}
               validationText={handleShowErrorMessage(
                  fieldNameUpperCase,
                  claimFieldErrorsMessages
               )}
            />
         </div>
      </WholeLineContainer>
   );
};

export default ThroutfulPersonIsContactAddressDifferent;
